'use strict';

import { AdType, DefaultInterstitialPlacement } from '../constants/AdType';
import { extendDefaults, getScript } from '../utils/common';
import { dankLog } from '../utils/dankLog';
import EventBus from '../components/EventBus';
import URLParse from 'url-parse';

// Only these mean our own wiring is wrong. Everything else that is not 'viewed' —
// frequencyCapped, noAdPreloaded, other, dismissed, ignored — is Google deciding
// not to show an ad, which is the common case and not an error.
const AD_BREAK_FAULTS = ['notReady', 'timeout', 'error', 'invalid'];

class AdInstance {
  constructor(e, options, n) {
    var defaultOptions = {
      debug: !1,
      width: 640,
      height: 360,
      locale: 'en',
    };
    this.options = options ? extendDefaults(defaultOptions, options) : defaultOptions;
    this.prefix = 'g8plugin__';
    this.adsLoader = null;
    this.adsManager = null;
    this.adDisplayContainer = null;
    this.eventBus = new EventBus();
    this.placementType = null;
    this.containerTransitionSpeed = 0;
    this.requestRunning = !1;
    this.parentDomain = n.parentDomain;
    this.topDomain = n.topDomain;
    this.parentURL = n.parentURL;
    this.adDisplayContainerInitialized = !1;
    this.IMASampleTags = {
      interstitial: [
        'https://pubads.g.doubleclick.net/gampad/ads?sz=640x480&iu=/124319096/external/single_ad_samples&ciu_szs=300x250&impl=s&gdfp_req=1&env=vp&output=vast&unviewed_position_start=1&cust_params=deployment%3Ddevsite%26sample_ct%3Dskippablelinear&correlator=',
        'https://pubads.g.doubleclick.net/gampad/ads?sz=640x480&iu=/124319096/external/single_ad_samples&ciu_szs=300x250&impl=s&gdfp_req=1&env=vp&output=vast&unviewed_position_start=1&cust_params=deployment%3Ddevsite%26sample_ct%3Dredirectlinear&correlator=',
        'https://pubads.g.doubleclick.net/gampad/ads?sz=640x480&iu=/124319096/external/single_ad_samples&ciu_szs=300x250&impl=s&gdfp_req=1&env=vp&output=vast&unviewed_position_start=1&cust_params=deployment%3Ddevsite%26sample_ct%3Dredirecterror&correlator=',
      ],
      rewarded: [
        'https://pubads.g.doubleclick.net/gampad/ads?sz=640x480&iu=/124319096/external/single_ad_samples&ciu_szs=300x250&impl=s&gdfp_req=1&env=vp&output=vast&unviewed_position_start=1&cust_params=deployment%3Ddevsite%26sample_ct%3Dlinear&correlator=',
      ],
    };
    this.atom_display;
    this.adType_ = '';
    this.clickCount = {
      midroll: 0,
      preroll: 0,
      rewarded: 0,
    };

    this.category = '';
    this.tags = [];
  }

  async start() {
    var self = this;
    await this.adSystemInitialize(async () => {
      let parser = new URLParse(location.href, true);

      let adsenseOptions = extendDefaults(this.options.adsense || {}, {
        adsense_client: 'ca-pub-8878309264050874',
        // Test mode renders mock ads without contacting Google, so it verifies the
        // callbacks and the pause/resume wiring on any host — including staging,
        // whose domain AdSense has never approved.
        adsense_adbreak_test: parser.query['adbreak_test'] === 'on',
      });

      await self._init_afg_script(adsenseOptions);
    });
    self.afgInitSuccess = true;

    await this.adSystemInitialize(async () => {
      await self._init_hl_script();
      await self._init_ima_script();
      await self._createPlayer();
      await self._setUpIMA();
    });
    self.imaInitSuccess = true;
  }
  async adSystemInitialize(callback) {
    var result = {
      success: false,
    };
    try {
      await callback();
      result.success = true;
    } catch (error) {
      console.error('adSystemInitialize error', error);
      result.error = error;
    }
    return result;
  }
  _requestPromo = function (e, t) {
    console.log('needImplement _requestPromo', e, t);
  };
  _requestAd = function (v, b) {
    console.log('needImplement _requestAd', v, b);
  };
  _getExternalVast = function (e) {
    console.log('needImplement _getExternalVast', e);
  };

  /**
   * cancel
   * Makes it possible to stop an advertisement while its
   * loading or playing. This will clear out the adsManager, stop any
   * ad playing and allowing new ads to be called.
   * @public
   */
  cancel() {
    if (this.requestRunning === false) return;

    this.requestRunning = false;

    this._resetAdsLoader();

    // Hide the advertisement.
    this._hide('cancel');

    // Send event to tell that the whole advertisement thing is finished.
    let eventName = 'AD_SDK_CANCELED';
    let eventMessage = 'Advertisement has been canceled.';
    this.eventBus.broadcast(eventName, {
      name: eventName,
      message: eventMessage,
      status: 'warning',
    });
  }

  _checkAutoPlay = function (e) {
    console.log('needImplement _checkAutoPlay', e);
  };
  _initDisplayContainerWithAutoPlay = function (e) {
    console.log('needImplement _initDisplayContainerWithAutoPlay', e);
  };
  async startAd(t) {
    var r = t.adType;
    var o = t.params || {};
    o.adType = t.adType;
    this.adType_ = r;
    this.isAudioAd = false;
    this.adContext = o;
    if (o.adapter === 'promo') return this._startPromo(o, r);
    if (o.adapter === 'adsense') {
      if (r === AdType.Rewarded) return this._startAdsensePlacementRewardedAd(t);
      if (r === AdType.Interstitial) {
        // Plugin.showAd has already resolved o.position against InterstitialPlacements.
        if (o.position === 'preroll') return this._startAdsensePlacementPreroll(t);
        return this._startAdsenseInterstitial(t, o.position || DefaultInterstitialPlacement);
      }
      throw new Error('Unsupported ad type');
    }
  }
  _hide = function (e) {
    if (this.video_ad_player) this.video_ad_player.src = '';
    if (this.activeAdContainer) this.activeAdContainer.style.visibility = 'hidden';
  };
  _show = function (e) {
    // needImplement
  };
  _setUpIMA = function () {
    // this.adDisplayContainer = new google.ima.AdDisplayContainer(this.adContainerInner,this.video_ad_player),
    // this.adsLoader = new google.ima.AdsLoader(this.adDisplayContainer),
    // this.adsLoader.getSettings().setDisableCustomPlaybackForIOS10Plus(!0),
    // this.adsLoader.getSettings().setLocale(this.options.locale),
    // this.adsLoader.getSettings().setVpaidMode(this._getVPAIDMode()),
    // this.adsLoader.getSettings().setAutoPlayAdBreaks(!0);
    // var e = this.adsLoader.getSettings().getNumRedirects();
    // this.adsLoader.getSettings().setNumRedirects(2 * e),
    // this.adsLoader.addEventListener(google.ima.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED, this._onAdsManagerLoaded, !1, this),
    // this.adsLoader.addEventListener(google.ima.AdErrorEvent.Type.AD_ERROR, this._onAdError, !1, this)
  };

  _resetAdsLoader() {
    if (this.adsManager) {
      this.adsManager.destroy();
      this.adsManager = null;
    }

    if (this.adsLoader) {
      this.adsLoader.contentComplete();
    }
  }

  /**
   * Only used where the host page has no tag of its own — h5, and any site
   * embedding the published plugin. On the portal app.html gets there first and
   * getScript bails out, so these attributes are ignored there by design.
   * No data-page-url: the plugin always runs on the domain being reported.
   */
  async _init_afg_script(options) {
    options = options || {};
    var attrs = {};
    attrs['crossorigin'] = 'anonymous';
    attrs['data-ad-client'] = options.adsense_client || 'ca-pub-8878309264050874';
    attrs['data-ad-frequency-hint'] = '30s';
    if (options.adsense_adbreak_test) attrs['data-adbreak-test'] = 'on';
    await getScript(
      'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js',
      'g8plugin_afg',
      {
        attrs: attrs,
        error_prefix: 'Blocked:',
        exists: function () {
          return !!window.adsbygoogle;
        },
      },
    ).then(function () {
      window.adsbygoogle = window.adsbygoogle || [];
      window.adsbygoogle.push({
        sound: 'on',
        preloadAdBreaks: 'on',
      });
    });
  }
  _init_hl_script = function () {};
  _init_ima_script = function () {};
  _createPlayer = function () {};

  _broadcast = function (t, e) {
    e = e || {};
    // A default, not an override. Two rewarded-ad AD_ERROR paths pass
    // skipForward: true to keep an outcome the game already learns from the
    // showAd() promise out of its event stream; assigning unconditionally
    // discarded that and forwarded the duplicate anyway.
    e.skipForward = e.skipForward ?? false;
    e.adPosition = this.placementType;
    this.eventBus.broadcast(t, e);
  };
  resetForNext = function () {
    this.requestRunning = false;
  };

  // Per-format revenue is not reachable from here: data-ad-channel is a script-tag
  // attribute set once per page load, so it cannot tell a preroll apart from a later
  // break on the same page. GA4 gets the per-break status instead.
  _reportAdBreak = function (type, breakStatus) {
    var faulted = AD_BREAK_FAULTS.indexOf(breakStatus) !== -1;

    if (faulted) console.error(`g8plugin: ad break "${type}" failed with "${breakStatus}"`);
    else if (breakStatus !== 'viewed')
      dankLog('AD_BREAK', type + ' skipped: ' + breakStatus, 'info');

    if (typeof window.gtag !== 'function') return;
    window.gtag('event', 'ad_break', {
      ad_placement: type,
      break_status: breakStatus,
      ad_shown: breakStatus === 'viewed',
      ad_fault: faulted,
      game_id: this.gameData && this.gameData.gameId,
    });
  };

  /**
   * preloadAd
   * Destroy the adsManager so we can grab new ads after this.
   * If we don't then we're not allowed to call new ads based
   * on google policies, as they interpret this as an accidental
   * video requests. https://developers.google.com/interactive-
   * media-ads/docs/sdks/android/faq#8
   * @param {String} adType
   * @return {Promise<any>}
   * @public
   */
  async preloadAd(adType) {
    if (adType === AdType.Interstitial || adType === AdType.Rewarded) return 'g8sdk://preloaded';
    throw new Error('Unsupported ad type');
  }

  async _startAdsensePlacementPreroll(t) {
    if (this.requestRunning) {
      this._broadcast('AD_IS_ALREADY_RUNNING', {
        status: 'warning',
      });
      return;
    }
    this.requestRunning = true;
    this.placementType = 'preroll';
    var adBreakDone = function (e) {
      this.resetForNext();
      this._reportAdBreak('preroll', e.breakStatus);
      if (e.breakStatus === 'viewed') {
        this._broadcast('CONTENT_PAUSE_REQUESTED', {
          message: '',
          status: 'success',
        });
        this._broadcast('IMPRESSION', {
          message: '',
          status: 'success',
        });
        this._broadcast('COMPLETE', {
          message: '',
          status: 'success',
        });
        this._broadcast('AD_SUCCESS', {
          message: 'Ad succeeded.',
          status: 'success',
        });
        this._broadcast('CONTENT_RESUME_REQUESTED', {
          message: '',
          status: 'success',
        });
      } else {
        this._broadcast('AD_ERROR', {
          message: e.breakStatus,
          status: 'error',
        });
      }
    }.bind(this);
    await window.adsbygoogle.push({
      type: 'preroll',
      adBreakDone: adBreakDone,
    });
  }
  /**
   * Every interstitial placement except preroll: 'next', 'start', 'pause', 'browse'.
   * They differ only in the word sent to Google, so they share one implementation.
   * Preroll stays separate because the API forbids beforeAd/afterAd there.
   */
  _startAdsenseInterstitial = async function (t, type) {
    if (this.requestRunning) {
      this._broadcast('AD_IS_ALREADY_RUNNING', {
        status: 'warning',
      });
      return;
    }
    this.requestRunning = true;
    this.placementType = type;

    // Google skips a break far more often than it fills one (frequency cap, no ad
    // preloaded), and those paths never call afterAd. Resume has to be reachable
    // from both sides without the game hearing about it twice.
    var resumed = false;
    var resume = function () {
      if (resumed) return;
      resumed = true;
      this._broadcast('CONTENT_RESUME_REQUESTED', {
        message: '',
        status: 'success',
      });
    }.bind(this);

    var beforeAd = function () {
      this._broadcast('IMPRESSION', {
        message: '',
        status: 'success',
      });
    }.bind(this);

    var adBreakDone = function (e) {
      this.resetForNext();
      this._reportAdBreak(type, e.breakStatus);
      if (e.breakStatus === 'viewed') {
        this._broadcast('COMPLETE', {
          message: '',
          status: 'success',
        });
        this._broadcast('AD_SUCCESS', {
          message: 'Ad succeeded.',
          status: 'success',
        });
      } else {
        this._broadcast('AD_ERROR', {
          message: e.breakStatus,
          status: 'error',
        });
      }
      resume();
    }.bind(this);

    // Policy: gameplay must be paused and muted before the ad runs. Google puts that
    // in beforeAd and requires it to happen synchronously, but the game sits in a
    // cross-origin iframe and only learns about it through postMessage, which cannot
    // be. Pausing before the break starts is the only ordering that actually holds.
    this._broadcast('CONTENT_PAUSE_REQUESTED', {
      message: '',
      status: 'success',
    });

    return window.adsbygoogle.push({
      type: type,
      name: 'g8-' + type,
      beforeAd: beforeAd,
      afterAd: resume,
      adBreakDone: adBreakDone,
    });
  };
  _startAdsensePlacementRewardedAd = async function (t) {
    if (this.requestRunning) {
      this._broadcast('AD_IS_ALREADY_RUNNING', {
        status: 'warning',
      });
      return;
    }
    this.requestRunning = true;
    this.placementType = 'reward';

    var adsConnected = false;
    var beforeAd = function () {
      adsConnected = true;
      this._broadcast('IMPRESSION', {
        message: '',
        status: 'success',
      });
    }.bind(this);
    var afterAd = function () {
      adsConnected = true;
      this._broadcast('CONTENT_RESUME_REQUESTED', {
        message: '',
        status: 'success',
      });
    }.bind(this);
    var adDismissed = function () {
      adsConnected = true;
    }.bind(this);
    var adViewed = function () {
      adsConnected = true;
      this._broadcast('COMPLETE', {
        message: '',
        status: 'success',
      });
      this._broadcast('SDK_REWARDED_WATCH_COMPLETE', {
        message: '',
        status: 'success',
      });
    }.bind(this);
    var beforeReward = function (callback) {
      adsConnected = true;
      callback();
    }.bind(this);
    var adBreakDone = function (e) {
      adsConnected = true;
      this.resetForNext();
      this._reportAdBreak('reward', e.breakStatus);
      if ('viewed' === e.breakStatus) {
        this._broadcast('AD_SUCCESS', {
          message: 'Ad succeeded.',
          status: 'success',
        });
      } else {
        this._broadcast('AD_ERROR', {
          message: e.breakStatus,
          status: 'error',
          skipForward: true,
        });
      }
    }.bind(this);
    var showAd = function (e) {
      window.adsbygoogle.push(e);
    };
    // Same ordering as _startAdsenseInterstitial: the pause has to reach the game
    // before adBreak(), beforeAd is too late for a cross-frame postMessage.
    this._broadcast('CONTENT_PAUSE_REQUESTED', {
      message: '',
      status: 'success',
    });
    setTimeout(
      function () {
        if (!adsConnected) {
          dankLog('AD_BREAK', 'reward: no callback within 1s', 'warning');
          this.requestRunning = !1;
          this._broadcast('AD_ERROR', {
            message: 'timeout',
            status: 'error',
            skipForward: true,
          });
        }
      }.bind(this),
      1000,
    );
    showAd({
      type: 'reward',
      name: 'reward-in-game',
      beforeAd: beforeAd,
      afterAd: afterAd,
      adDismissed: adDismissed,
      adViewed: adViewed,
      beforeReward: beforeReward,
      adBreakDone: adBreakDone,
    });
  };
}

export default AdInstance;
